import React from 'react';
import { useTranslation } from 'react-i18next';

import helpers from 'utils/helpers';

const FirstMileProvider = (props) => {
  const { boxStyles, imageStyles, textStyles, slug } = props;
  const { t } = useTranslation();

  const renderProviderImage = () => {
    const images = helpers.getCarrierImage(slug);
    
    return (
      <img
        src={images['3x']}
        srcSet={`
          ${images['1x']} 1x,
          ${images['2x']} 2x,
          ${images['3x']} 3x
        `}
        style={{
          width: helpers.getCarrierImageWidth(slug, 0.9),
          ...(imageStyles || {})
        }}
        alt={`${slug} logo`}
        onError={i => (i.target.style.display = 'none')}
      />
    );
  };

  const renderProviderName = () => {
    return t(`pickup.form.first_mile.${slug}`);
  };

  const renderProviderTitle = () => {
    const firstMileProvider = renderProviderName();
    return t('pickup.form.pickup_by_first_mile', { firstMileProvider })
  }

  if (!slug) return null;
  return (
    <div style={boxStyles || {}}>
      <span>{renderProviderImage()}</span>
      <span
        style={{
          fontSize: '12px',
          paddingLeft: '3px',
          verticalAlign: 'middle',
          color: '#2C2C2E',
          ...(textStyles || {}),
        }}
      >
        {renderProviderTitle()}
      </span>
    </div>
  );
};

export default FirstMileProvider;